<template>
  <v-app>
    <Header :isPublic="true" />
    <v-main>
      <div id="body">

      <v-container fluid class="body_content">
        <v-alert text type="info">
          <small class="text-info">
            Informação atualizada até {{ returnDateNow() }}
          </small>
        </v-alert>

        <h2>Pesquisa de Súmula</h2>

        <v-row>
          <v-col cols="12" md="3">
            <v-text-field
                label="Pesquisar por Enunciado"
                v-model="filtro.enunciado"
                v-on:keyup.enter="buscar()"
            />
          </v-col>
          <v-col cols="12" md="1">
            <v-text-field
                type="number"
                label="Número"
                v-model="filtro.numero"
                v-on:keyup.enter="buscar()"
            />
          </v-col>

          <v-col md="3" cols="12" style="margin-top: 1.1%">
            <v-select
                solo
                dense
                item-text="Súmulas do TCE"
                label="Súmulas do TCE"
                disabled
            ></v-select>
          </v-col>

          <v-col cols="12" md="1" style="margin-top: 1.4%">
            <v-btn
                style
                color="primary"
                small
                depressed
                :loading="loadingBusca"
                :disabled="loadingBusca"
                @click="buscar()"
            >
              <v-icon small>fa-search</v-icon>
            </v-btn>
          </v-col>
        </v-row>

        <v-alert v-if="erroServico" type="error" outlined dense class="mt-4">
          Não foi possível consultar as súmulas no momento. Tente novamente em instantes.
        </v-alert>

        <v-row justify="center">
          <v-col cols="12" md="12">
            <template>
              <v-data-table
                  @click:row="abrirDialog"
                  :headers="headers"
                  :items="lista"
                  :items-per-page="10"
                  :loading="loadingBusca"
                  class="elevation-1 mytable"
                  no-results-text="A busca não trouxe resultados."
                  :no-data-text="erroServico ? 'Não foi possível carregar os dados.' : 'A busca não trouxe resultados.'"
              >
                <template v-slot:loading>
                  <LoadingSpinner text="Carregando súmulas... aguarde." />
                </template>

                <template v-slot:item.enunciadoLimit="{ item }">
                  {{
                    item.enunciado.substr(0, 200) + ' [...]'
                  }}
                </template>

                <template v-slot:item.dataSessaoFormatada="{ item }">
                <span>
                  {{
                    item.dataSessao
                        ? $moment(item.dataSessao).format("DD/MM/YYYY")
                        : "Não Informado"
                  }}
                </span>
                </template>
                <template v-slot:item.dataDiarioFormatada="{ item }">
                <span>
                  {{
                    item.dataDiario
                        ? $moment(item.dataDiario).format("DD/MM/YYYY")
                        : "Não Informado"
                  }}
                </span>
                </template>
              </v-data-table>
            </template>

            <v-dialog v-model="dialog" max-width="900px">
              <v-card>
                <v-card-title class="grey lighten-2"
                >Referente ao Processo: {{ sumula.numeroProcesso }}/{{ sumula.anoProcesso }}
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" md="2">
                        <v-text-field
                            disabled
                            class="font-weight-black"
                            label="Processo"
                            v-model="sumula.numeroProcesso"
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12" md="2">
                        <v-text-field
                            disabled
                            class="font-weight-black"
                            label="Ano"
                            v-model="sumula.anoProcesso"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="3">
                        <v-text-field
                            disabled
                            type="date"
                            class="font-weight-black"
                            label="Data da Sessão"
                            v-model="sumula.dataSessao"
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12" md="3">
                        <v-text-field
                            disabled
                            type="date"
                            class="font-weight-black"
                            label="Diário Oficial"
                            v-model="sumula.dataDiario"
                        ></v-text-field>
                      </v-col>

                    </v-row>

                    <v-row>
                      <v-col cols="12" md="12">
                        <v-textarea
                            disabled
                            class="font-weight-black"
                            rows="2"
                            outlined
                            auto-grow
                            counter
                            name="enunciadoArea"
                            label="Enunciado"
                            v-model="sumula.enunciado"
                        ></v-textarea>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="12" md="12">
                        <v-textarea
                            disabled
                            class="font-weight-black"
                            rows="2"
                            outlined
                            auto-grow
                            counter
                            name="fundamentoArea"
                            label="Fundamentação Legal"
                            v-model="sumula.fundamentacao"
                        ></v-textarea>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="12" md="12">
                        <v-textarea
                            disabled
                            class="font-weight-black"
                            rows="2"
                            outlined
                            auto-grow
                            counter
                            name="precedentesArea"
                            label="Precedentes"
                            v-model="sumula.precedentes"
                        ></v-textarea>
                      </v-col>
                    </v-row>


                  </v-container>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" text @click="dialog = false"
                  >Fechar
                  </v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-col>
        </v-row>
      </v-container>
      </div>
    </v-main>
  </v-app>
</template>

<script>
import Header from "@/components/template/Header.vue";
import LoadingSpinner from "@/components/template/LoadingSpinner.vue";
import sumulaService from "@/service/SumulaService";

export default {
  components: {
    Header,
    LoadingSpinner
  },
  data() {
    return {
      dialog: false,
      loadingBusca: false,
      erroServico: false,
      filtro: {
        numero: null,
        enunciado: null,
      },
      lista: [],
      sumula: {
        enunciado: null,
        numeroProcesso: null,
        anoProcesso: null,
        dataSessao: null,
        dataDiario: null,
        fundamentacao: null,
        precedentes: null,
        palavrasChave: null,
      },
      headers: [
        {text: "Súmula Nº", value: "numero", sortable: false},
        {text: "Enunciado", value: "enunciadoLimit", sortable: false, width: "50%"},
        {text: "Processo", value: "numeroProcesso", sortable: false},
        {text: "Ano", value: "anoProcesso", sortable: false},
        {text: "Data Sessão", value: "dataSessaoFormatada", sortable: false},
        {text: "Data Diário", value: "dataDiarioFormatada", sortable: false},
      ],
    };
  },
  methods: {
    returnDateNow() {
      return this.$moment().format("DD/MM/YYYY");
    },

    buscar() {
      if (this.loadingBusca) return; //evita disparar buscas empilhadas pelo enter
      this.loadingBusca = true;
      this.erroServico = false;
      this.lista = []; //limpa antes: senão a tabela mostra os resultados antigos + a barra em vez do spinner
      sumulaService
          .buscarFiltro(this.filtro)
          .then((result) => (this.lista = result || []))
          .catch(() => {
            // falha real (rede/API fora do ar): aviso de indisponibilidade
            this.lista = [];
            this.erroServico = true;
          })
          .finally(() => (this.loadingBusca = false));
    },
    abrirDialog(item) {
      Object.assign(this.sumula, item);
      this.dialog = true;
    },
  },
  created() {
    sumulaService.findAll()
      .then((res) => (this.lista = res))
      .catch(() => (this.erroServico = true));
  },
};
</script>

<style scoped>
.body_content {
  margin: auto;
  padding: 2rem 5rem;
}

.text-info {
  color: #000000;
}
</style>